import type { Geolocation } from "@packages/sdk";
import type { Dispatch, SetStateAction } from "react";

import { DEFAULT_CONSENT_OPTIONS } from "../constants/defaultConsentOptions.constants";
import { DEFAULT_CONSENT_OPTIONS_STRICT } from "../constants/defaultConsentOptionsStrict.constants";
import type { ConsentContext } from "../lib/consentContext";
import { getGeolocationStrictConsentPermissions } from "./getGeolocationStrictConsentPermissions";

type HandleConsentFromGeolocationProps = {
  geolocation: Geolocation;
  setConsent: Dispatch<SetStateAction<ConsentContext["consent"]>>;
  setCountryCode: Dispatch<SetStateAction<ConsentContext["countryCode"]>>;
  setIsConsentModalVisible: Dispatch<SetStateAction<boolean>>;
};

/**
 * default: use DEFAULT_CONSENT_OPTIONS
 * strict IP: use DEFAULT_CONSENT_OPTIONS_STRICT
 * strict IP: show consent modal
 */
export const handleConsentFromGeolocation = ({
  geolocation,
  setConsent,
  setCountryCode,
  setIsConsentModalVisible,
}: HandleConsentFromGeolocationProps) => {
  if (geolocation) {
    const isGeolocationStrictConsentPermissions =
      getGeolocationStrictConsentPermissions({
        geolocation,
      });

    setConsent(
      !isGeolocationStrictConsentPermissions
        ? DEFAULT_CONSENT_OPTIONS
        : DEFAULT_CONSENT_OPTIONS_STRICT,
    );
    setCountryCode(geolocation.country);
    setIsConsentModalVisible(!!isGeolocationStrictConsentPermissions);
    /** Default configuration */
  } else {
    const isLocalDevelopment = process.env.NODE_ENV === "development";
    setConsent(
      isLocalDevelopment
        ? DEFAULT_CONSENT_OPTIONS
        : DEFAULT_CONSENT_OPTIONS_STRICT,
    );
    setIsConsentModalVisible(!isLocalDevelopment);
  }
};
